import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  FilterFormActions,
  FilterFormClearButton,
  FilterFormSubmitButton,
} from 'components/filters/FilterFormButtons';
import useFilterFormContextApplyFiltersStoredValues from 'components/filters/useFilterFormContextApplyFiltersStoredValues';
import useFilterFormContextFormHandlers from 'components/filters/useFilterFormContextFormHandlers';
import PropertyMultiSelectField from 'components/forms/domain/property/PropertyMultiSelectField/PropertyMultiSelectField';
import { Form } from 'components/forms/form/Form';
import CommonFiltersContainer from 'pages/automations/common/CommonFiltersContainer';
import ChannelMultiSelectField from '../common/ChannelMultiSelectField';
import RecipientMultiSelectField from '../common/RecipientMultiSelectField';
import { TriggersTabFiltersSchemaType } from './TriggersTabFilters.schema';
import ActionTypeMultiSelectField from './fields/ActionTypeMultiSelectField';
import EventTypeMultiSelectField from './fields/EventTypeMultiSelectField';
import TemplateMultiSelectField from './fields/TemplateMultiSelectField';
import TriggerSearchField from './fields/TriggerSearchField';
import useSearchedTrigger from './useSearchedTrigger';

const TriggersTabFilters = () => {
  const { t } = useTranslation();
  const { handleClear, handleSubmit } =
    useFilterFormContextFormHandlers<TriggersTabFiltersSchemaType>();
  const isTriggersSearchActive = !!useSearchedTrigger();

  useFilterFormContextApplyFiltersStoredValues();

  return (
    <CommonFiltersContainer
      searchField={<TriggerSearchField />}
      stateStorageKey="triggers-tab-filters-expanded"
    >
      <Form
        data-testid="triggers-tab-filters-form"
        horizontal
        onSubmit={handleSubmit}
      >
        <Row>
          <Col md={4} sm={6}>
            <EventTypeMultiSelectField
              disabled={isTriggersSearchActive}
              name="eventTypes"
            />
          </Col>
          <Col md={4} sm={6}>
            <ActionTypeMultiSelectField
              disabled={isTriggersSearchActive}
              name="actionTypes"
            />
          </Col>
          <Col md={4} sm={6}>
            <RecipientMultiSelectField
              disabled={isTriggersSearchActive}
              label={t('pageAutomations.triggers.filters.recipients')}
              name="recipients"
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} sm={6}>
            <TemplateMultiSelectField
              disabled={isTriggersSearchActive}
              name="templateUids"
            />
          </Col>
          <Col md={4} sm={6}>
            <ChannelMultiSelectField
              disabled={isTriggersSearchActive}
              label={t('pageAutomations.triggers.filters.channels')}
              name="channels"
            />
          </Col>
          <Col md={4} sm={6}>
            <PropertyMultiSelectField
              colSmInput={8}
              colSmLabel={4}
              disabled={isTriggersSearchActive}
              enableHotels={false}
              enableUnitTypes
              isSelectAllEnabled
              label={t('pageAutomations.triggers.filters.properties')}
              name="properties"
              placeholder={t('common.selectOption')}
            />
          </Col>
        </Row>

        <FilterFormActions>
          <FilterFormClearButton onClick={handleClear} />
          <FilterFormSubmitButton disabled={isTriggersSearchActive} />
        </FilterFormActions>
      </Form>
    </CommonFiltersContainer>
  );
};

export default TriggersTabFilters;
